import React, { memo } from 'react'
import { oneOf, string } from 'prop-types'
import SVG from './SVG'

export const ArrowsNavigation = memo(({ direction = 'first', fill, height = '17px', width = '40px' }) => {
	const rotate = direction === 'first' ? -315 : 225
	return (
		<SVG
			fill={fill}
			width={width}
			height={height}
			viewBox={direction === 'first' ? '8 0 12 25' : ' 20 0 5 25'}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g xmlns="http://www.w3.org/2000/svg">
				d
				<path
					d="M17,4 L21,4 L21,16.999 L34,17 L34,21 L17,21 L17,4 Z"
					id="Combined-Shape"
					transform={`translate(25.500000, 12.500000) rotate(${rotate}) translate(-25.500000, -12.500000)`}
				/>
				<path
					d="M4,4 L8,4 L8,16.999 L21,17 L21,21 L4,21 L4,4 Z"
					id="Combined-Shape"
					transform={`translate(12.500000, 12.500000) rotate(${rotate}) translate(-12.500000, -12.500000)`}
				/>
			</g>
		</SVG>
	)
})

ArrowsNavigation.propTypes = {
	direction: oneOf(['first', 'last']),
	fill: string,
	height: string,
	width: string,
}
